<template>
  <div>
    <CreationFormEmail
      v-if="isAtRegisterWithEmail()"
      class="cms-styles-adaption"
      @account:created="handleAccountCreated"
      @goToPostcodeAndBirthdate="setStatusToPostCodeAndBirthdate"
    ></CreationFormEmail>

    <CreationFormPostcodeAndBirthdate
      v-if="isAtRegisterWithPostcodeAndBirthdate()"
      :initial-email="email"
      :initial-vsnr="vsnr"
      @account:created="handleAccountCreated"
    ></CreationFormPostcodeAndBirthdate>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import CreationFormEmail from '@/components/account-management/accountcreation/CreationFormEmail.vue'
import CreationFormPostcodeAndBirthdate from '@/components/account-management/accountcreation/CreationFormPostcodeAndBirthdate.vue'
import { ButtonColor } from 'de-zurich-ui-library'
import { navigate } from '@/utils/NavigationUtils'
import type { OrchestrateAccountsResponse } from 'account-api'

enum RegisterStatus {
  EMAIL,
  POSTCODE_AND_BIRTHDATE
}

defineProps({
  buttonColor: {
    type: String,
    required: false,
    default: ButtonColor.PRIMARY
  }
})

const status = ref(RegisterStatus.EMAIL)
let vsnr = ''
let email = ''

function isAlreadyActivatedMessage(message?: string): boolean {
  return message?.includes('bereits in der Vergangenheit aktiviert') ?? false
}

function handleAccountCreated(response?: OrchestrateAccountsResponse) {
  if (isAlreadyActivatedMessage(response?.message)) {
    navigate(globalThis.ENV_CONFIG?.REDIRECTS.USER_EXISTS_PAGE)
    return
  }
  navigate(globalThis.ENV_CONFIG?.REDIRECTS.ACCOUNT_CREATION_SUCCESS_PAGE)
}

const setStatusToPostCodeAndBirthdate = (_vsnr: string, _email: string): void => {
  vsnr = _vsnr
  email = _email
  status.value = RegisterStatus.POSTCODE_AND_BIRTHDATE
}

const isAtRegisterWithEmail = () => {
  return status.value === RegisterStatus.EMAIL
}

const isAtRegisterWithPostcodeAndBirthdate = () => {
  return status.value === RegisterStatus.POSTCODE_AND_BIRTHDATE
}
</script>
